export default class FormUtils {
  static prepareFormValues = <T extends object>(
    data: T,
    options?: {
      transformations?: { [K in keyof T]?: (value: T[K]) => any };
      excludeUndefined?: boolean;
    },
  ): Record<string, any> => {
    const result: Record<string, any> = {};

    Object.entries(data).forEach(([key, value]) => {
      // Приводим key к keyof T
      const typedKey = key as keyof T;

      if (value === undefined) {
        result[key] = options?.excludeUndefined ? undefined : null;
      } else {
        // Теперь TypeScript знает, что это keyof T
        const transform = options?.transformations?.[typedKey];
        result[key] = transform ? transform(value as T[keyof T]) : value;
      }
    });

    return result;
  };
}
